import React, { useState, useEffect } from 'react';
import MoreInfo from '../MoreInfo';
import ErrorMessage from './ErrorMessage';
import PropTypes from 'prop-types';

import extractSearchString from '../../utils/extractSearchString';
import { prepareCleanString } from '../../utils/unsupportedCharactersUtils';

const ERROR_MSG = 'Something went wrong, please try again later.';
const LOADING_MSG = 'Looking for your domain...';
const UNAVAILABLE_MSG =
  'It doesn’t look like that domain name is available. Try searching something else.';

function Step1({
  setQuery,
  setOriginalQuery,
  content = "Type your preferred domain name in the box and press 'Search' to check its availability.",
  query = '',
  originalQuery = '',
  loading = false,
  unavailable = false,
  error = false,
  helperStepOne,
  isJumpstarter,
  hasUnsupportedCharacters,
  helperUnsupportedCharacters,
  setHasUnsupportedCharacters,
}) {
  const [search, setSearch] = useState(originalQuery);

  useEffect(() => {    
    // for jumpstarter keep the search the full version inlcuding unsupported characters
    if (isJumpstarter && originalQuery !== search) {
      setSearch(originalQuery);
    } else if (!isJumpstarter && query !== search) {
      // for INZ search update the search field to display what was queried. 
      setSearch(query);
    }
  }, [query, isJumpstarter, originalQuery]);

  const stepDescription = content.replace(/(<([^>]+)>)/gi, '');
  let message = '';

  if (error) {
    message = ERROR_MSG;
  } else if (!error && unavailable) {
    if (!isJumpstarter && !hasUnsupportedCharacters) {
      message = UNAVAILABLE_MSG;
    }
  } else if (!error && loading) {
    message = LOADING_MSG;
  }


  const handleSubmit = e => {
    e.preventDefault();

    setOriginalQuery(search)
    let searchString = extractSearchString(search, isJumpstarter);
    if (isJumpstarter) {
      const cleanedString = prepareCleanString(searchString)
      setHasUnsupportedCharacters(cleanedString.length !== searchString.length)
      searchString = cleanedString
    } 
    searchString && setQuery(searchString);

    return false;
  };

  const clearSearch = e => {
    setSearch('');
    setQuery('');
    setHasUnsupportedCharacters(false);
    setOriginalQuery('');
  };

  return (
    <div className="wrapper">
      <div className="step__inner">
        <div className="step__content">
          <p className="headline">Step 1</p>
          <div className="step__title">
            <h2 className="h3">{isJumpstarter ? 'Check domain name availability' : 'Search your domain name'}</h2>
            <MoreInfo content={helperStepOne} isJumpstarter={isJumpstarter} />
          </div>
          <p
            className="h6 step__description"
            dangerouslySetInnerHTML={{ __html: stepDescription }}
          ></p>
        </div>
        <form onSubmit={handleSubmit} className="step-one__search">
          <label htmlFor="search-domain" className="visually-hidden _sr-only">
            Find a .nz domain
          </label>
          <input
            className="input--rounded input--domain-search"
            id="search-domain"
            type="text"
            value={search}
            placeholder="Find a .nz domain"
            onChange={e => setSearch(e.target.value)}
          />
          {isJumpstarter &&
            <button
              type="button"
              onClick={clearSearch}
              className={`step-one__clear-search ${search ? 'step-one__clear-search--active' : ''}`}
              aria-hidden={search ? false : true}
              tabIndex={search ? 0 : -1}
              title="Clear search"
            >
              <span className="_sr-only">Clear search</span>
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M32 1L1 32" stroke="#737373" style={{stroke:'#737373',stroke:'color(display-p3 0.4510 0.4510 0.4510)',strokeOpacity:1}} strokeWidth="2" strokeMiterlimit="10"/>
                <path d="M1 1L32 32" stroke="#737373" style={{stroke:'#737373',stroke:'color(display-p3 0.4510 0.4510 0.4510)',strokeOpacity:1}} strokeWidth="2" strokeMiterlimit="10"/>
              </svg>
            </button>
          }
          <button
            type="button"
            onClick={handleSubmit}
            className="button button--domain-search c-btn c-btn--no-clip"
          >
            {isJumpstarter ? "Go" : "Search"}
          </button>
          {message && (
            <ErrorMessage message={message} error={error} />
          )}
          {isJumpstarter && hasUnsupportedCharacters &&
            <>
              <div className={`c-domain-lookup__unsupported-message ${hasUnsupportedCharacters ? 'c-domain-lookup__unsupported-message--visible' : ""}`}>
                <div id="unsupported-chars-error-msg" className="c-domain-lookup__unsupported-text">
                  <span className="c-domain-lookup__unsupported-message-text">Some unsupported characters have been removed from your search.</span>
                  <span id="unsupported-chars-btn">
                    <MoreInfo content={helperUnsupportedCharacters} isJumpstarter={true} />
                  </span>
                </div>
                <div id="unsupported-chars-more-info" data-content="$HelperUnsupportedChars.ATT">
                </div>
              </div>
            </>
          }
        </form>
      </div>
    </div>
  );
}

Step1.propTypes = {
  setQuery: PropTypes.func,
  content: PropTypes.string,
  query: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  helperStepOne: PropTypes.string
};

export default Step1;
